import { createReducer } from '@reduxjs/toolkit';

import * as schedulerActions from './schedulerActions.js';

const initialState = {
  requesting: false,
  error: null,

  requestingDraft: false,
  errorDraft: null,
  isDraft: false,

  id: 0,
  title: '',
  content: '',
  images: [],
  fb: false,
  tw: false,
  ig: false,
  li: false,
  tg: false,
  pi: false,
  tr: false,
  di: false,

  publishResult: null,
};

const scheduler = createReducer(initialState, (builder) => {
  builder
    .addCase(schedulerActions.schedulerGetDraftRequest, (state) => ({ ...state, requestingDraft: true, errorDraft: null }))
    .addCase(schedulerActions.schedulerGetDraftError, (state, { payload }) => ({ ...state, errorDraft: payload, requestingDraft: false }))

    .addCase(schedulerActions.schedulerUpdateIsDraft, (state, { payload: isDraft }) => ({ ...state, isDraft }))

    .addCase(schedulerActions.schedulerGetDraftStore, (state, { payload: data }) => {
      console.log('get draft store');

      const {
        title,
        content,
        medias: images,
        isFacebook: fb,
        isTwitter: tw,
        isInstagram: ig,
        isLinkedIn: li,
        isTelegram: tg,
        isPinterest: pi,
        isThreads: tr,
        isDiscord: di,
      } = data;

      return {
        ...state,

        errorDraft: null,
        requestingDraft: false,

        isDraft: true,
        title,
        content,
        images,
        fb,
        tw,
        ig,
        li,
        tg,
        pi,
        tr,
        di,
      };
    })

    .addCase(schedulerActions.schedulerUpdatePostStore, (state, { payload: data }) => {
      const {
        title,
        content,
        medias: images,
        isFacebook: fb,
        isTwitter: tw,
        isInstagram: ig,
        isLinkedIn: li,
        isTelegram: tg,
        isPinterest: pi,
        isThreads: tr,
        isDiscord: di,
      } = data;

      return {
        ...state,

        title,
        content,
        images,
        fb,
        tw,
        ig,
        li,
        tg,
        pi,
        tr,
        di,
      };
    })

    .addCase(schedulerActions.schedulerUpdateRequest, (state) => ({ ...state, requesting: true, error: null }))
    .addCase(schedulerActions.schedulerUpdateError, (state, { payload }) => ({ ...state, error: payload, requesting: false }))
    .addCase(schedulerActions.schedulerUpdateStore, (state) => ({ ...state, error: false, requesting: false }))

    .addCase(schedulerActions.schedulerUpdateId, (state, { payload: id }) => ({ ...state, id }))
    .addCase(schedulerActions.schedulerUpdateTitle, (state, { payload: title }) => ({ ...state, title }))
    .addCase(schedulerActions.schedulerUpdateContent, (state, { payload: content }) => ({ ...state, content }))
    .addCase(schedulerActions.schedulerUpdateImages, (state, { payload: images }) => ({ ...state, images }))

    .addCase(schedulerActions.schedulerUpdateFB, (state, { payload: fb }) => ({ ...state, fb }))
    .addCase(schedulerActions.schedulerUpdateTW, (state, { payload: tw }) => ({ ...state, tw }))
    .addCase(schedulerActions.schedulerUpdateIG, (state, { payload: ig }) => ({ ...state, ig }))
    .addCase(schedulerActions.schedulerUpdateLI, (state, { payload: li }) => ({ ...state, li }))
    .addCase(schedulerActions.schedulerUpdateTG, (state, { payload: tg }) => ({ ...state, tg }))
    .addCase(schedulerActions.schedulerUpdatePI, (state, { payload: pi }) => ({ ...state, pi }))
    .addCase(schedulerActions.schedulerUpdateTR, (state, { payload: tr }) => ({ ...state, tr }))
    .addCase(schedulerActions.schedulerUpdateDI, (state, { payload: di }) => ({ ...state, di }))

    .addCase(schedulerActions.schedulerUpdatePublishResult, (state, { payload: publishResult }) => ({ ...state, publishResult }));
});

export default scheduler;
